import React from 'react';
import { connect } from 'react-redux';
import { getMenuFields } from 'layouts/AppLayout/getMenuItems';
import InviteFriend from 'components/InviteFriend';
import Sidebar from './Sidebar';
import BodyNotification from './BodyNotification';

const Body = ({ children, ...props }) => {
  const fields = getMenuFields({
    hasAchievements: props.hasAchievements,
  });
  return (
    <div className="dashboard__body__wrapper fl-row-justify-left">
      <div className="dashboard__body__wrapper__sidebar">
        <Sidebar menuItems={fields} />
        <div className="coupons">
          <InviteFriend />
        </div>
      </div>
      <div className="dashboard__body__wrapper__content">
        <BodyNotification
          requireAccountDetails={props.requireAccountDetails}
          requireIdVerification={props.requireIdVerification}
          customerCredits={props.customerCredits}
        />
        {children}
      </div>
    </div>
  );
};

const mapState = ({ profileStore }) => ({
  requireAccountDetails: profileStore.profile_data?.update_account || false,
  requireIdVerification: profileStore.profile_data?.should_verify_id || false,
  customerCredits: profileStore.profile_data?.customer_credits || 0,
  hasAchievements:
    profileStore.profile_data?.has_unlocked_achievements || false,
});

export default connect(mapState)(Body);
